
  import * as firebase from "firebase/app";
  import "firebase/firestore";
  import { ValidationRules } from "@/utils/validation-rules";
  import { Component, Vue } from "vue-property-decorator";
  import { getRegionName } from "@/utils/functionsRegion";
  import HeaderLogo from "@/views/login/HeaderLogo.vue";

  @Component({
    components: {
      HeaderLogo
    }
  })
  export default class ResetPassword extends Vue {
    password = "";
    repeatPassword = "";
    isVisiblePassword = false;
    isVisibleRepeatPassword = false;
    isFormValid = true;
    isLoading = false;
    isError = false;
    isPasswordSet = false;
    user = null;

    get rules() {
      return {
        password: [
          ValidationRules.required,
          ValidationRules.min(6),
          ValidationRules.number,
          ValidationRules.capitalLetter,
          ValidationRules.lowerLetter,
          ValidationRules.symbol
        ],
        repeatPassword: [
          ValidationRules.required,
          ValidationRules.min(6),
          ValidationRules.isEqualTo(this.password)
        ]
      };
    }

    get actionCode(): string {
      return this.$route.query.oobCode as string;
    }

    created() {
      firebase
        .firestore()
        .collection("users")
        .where("resetPasswordToken", "==", this.$route.params.token).get()
        .then((snap) => {
          if (snap.empty) {
            this.isError = true;
            this.$toast.open({
              message: "The link has already been used",
              type: "error"
            });
          }
          else if (snap.docs.length == 1) {
            this.user = snap.docs[0].data();
            this.user.id = snap.docs[0].id;
          }
          else if (snap.docs.length > 1) {
            this.isError = true;
            this.$toast.open({
              message: "The link has already been used",
              type: "error"
            });
          }
        })
    }

    async onSubmit() {
      // eslint-disable-next-line
      this.isFormValid = (this.$refs.form as any).validate();

      if (!this.isFormValid) return;

      this.isLoading = true;

      try {
        await firebase.app().functions(getRegionName()).httpsCallable('updateUserPassword')({
          staffHubUserId: this.user.id,
          newPassword: this.password
        }).then(() => {
          this.isPasswordSet = true;
          firebase
            .firestore()
            .collection('users')
            .doc(this.user.id)
            .update({ resetPasswordToken: null, passwordResetDateTime: firebase.firestore.Timestamp.now() }).then(() => {

              this.$store.dispatch("userSignIn", {
                email: this.user.email,
                password: this.password
              });

              this.$toast.open({
                message: "Password successfully changed",
                type: "success"
              });

              this.isLoading = false;
            })
        }).catch(() => {
          this.$toast.open({
            message: "Unable to set new password",
            type: "error"
          });
          this.isLoading = false;
        })


      } catch (e) {
        console.error(e);
      }

    }

  }
